// src/components/common/LoadingOverlay.js

import React from 'react';
import { useLoading } from '../../contexts/LoadingContext';

const LoadingOverlay = () => {
  const { isLoading } = useLoading();
  if (!isLoading) return null;

  return (
    <div className="loading-overlay" role="status" aria-label="Carregando">
      <div style={{ textAlign: 'center' }}>
        <div className="loading-spinner" />
        <p style={{
          color: 'var(--gold)',
          marginTop: '1rem',
          fontFamily: 'var(--font-display)',
          fontSize: '1rem',
          letterSpacing: '0.05em',
        }}>
          Aguarde...
        </p>
      </div>
    </div>
  );
};

export default LoadingOverlay;
